<template>
  <b-modal
    :visible="visible"
    centered
    hide-header
    hide-footer
    scrollable
    dialog-class="modal-color-black empty-email-dialog"
    @hide="onDialogHide"
  >
    <div class="empty-email-header">
      <h3>{{ $t('Add Participant') }}</h3>
    </div>

    <div class="empty-email-row">
      {{
        $t(
          'The person you selected has no email address. This person will not receive any notification emails. Are you sure you want to add this person to the list of Inspection participants?'
        )
      }}
    </div>

    <div class="empty-email-actions">
      <b-button pill size="sm" variant="secondary" class="text-uppercase btn-text mr-2" @click="onCancelClick">
        <span>{{ $t('confirm-cancel') }}</span>
      </b-button>

      <b-button pill size="sm" variant="primary" class="text-uppercase mx-2" @click="onConfirmClick">
        <span>{{ $t('Confirm') }}</span>
      </b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'EmptyEmailDialog',

  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    person: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      processing: false,
    };
  },

  methods: {
    onDialogHide() {
      this.$emit('hide');
    },

    onConfirmClick() {
      this.$emit('confirm');
    },

    onCancelClick() {
      this.$emit('cancel');
    },
  },
};
</script>

<style>
.empty-email-dialog .modal-body {
  padding: 32px 52px;
}
</style>

<style scoped>
.empty-email-header {
  border-bottom: 2px solid var(--bs-gray-500);
}

.empty-email-actions {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 32px;
}

.empty-email-row {
  min-height: 42px;
  padding: 8px 0;
  border-bottom: 1px solid var(--bs-gray-500);
}

.empty-email-actions {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 32px;
}
</style>



// WEBPACK FOOTER //
// src/components/projectplan/EmptyEmailDialog.vue